import { render, staticRenderFns } from "./ConsultantsIndexComponent.vue?vue&type=template&id=6768aeef"
import script from "./ConsultantsIndexComponent.vue?vue&type=script&lang=js"
export * from "./ConsultantsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports